import angular from 'angular';
import { filter, map, random } from 'lodash';

import { getErrorMessage } from 'application/util/error.util';
import { isCategoryListable, categoryHasTerms } from 'application/util/category.util';

import './category-manage-modal.style.sass';
import template from './category-manage-modal.tpl.pug';

class CategoryManageModalController {
    /* @ngInject */
    constructor(categoryService, modalService, notificationService, storageService) {
        this.categoryService = categoryService;
        this.modalService = modalService;
        this.notificationService = notificationService;
        this.storageService = storageService;
    }

    $onInit() {
        this.sortableOptions = {
            animation: 100,
            onEnd: this.endSort.bind(this)
        };

        this.categories = [];
        const categoryIconStyle = this.storageService.getUserItem('category-icon-style') || 'icons';
        this.useCategoryIcons = categoryIconStyle === 'icons';
        this.categoryService.onUpdate(this.handleCategoryUpdate.bind(this));

        this.reload().finally(() => {
            this.searchPlaceholder = this.categories && this.categories.length > 0
                ? `search for e.g. ${this.categories[random(0, this.categories.length - 1)].name}`
                : null;
        });
    }

    reload(force) {
        this.loading = true;

        return this.load(typeof force === 'undefined' ? true : force).finally(() => this.loading = false);
    }

    handleCategoryUpdate(updatedCategory) {
        if (!updatedCategory || !updatedCategory.id) {
            return this.reload(true);
        }

        let replaced = false;
        this.categories = map(this.categories || [], (category) => {
            if (`${category.id}` === `${updatedCategory.id}`) {
                replaced = true;
                return angular.merge({}, category, updatedCategory);
            }

            return category;
        });

        if (!replaced) {
            return this.reload(true);
        }

        return this.search();
    }

    load(force) {
        return this.categoryService.getAll(this.teamId, force).then((categories) => {
            this.categories = filter(categories, isCategoryListable);
            this.search();
        }).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to load your categories. Please try again later.`));
        });
    }

    create() {
        return this.openCategory();
    }

    select(category) {
        return this.openCategory(category);
    }

    openCategory(category) {
        return this.modalService.open({
            component: 'dbACategoryEditModal',
            bindings: {
                teamId: this.teamId,
                category: angular.merge({}, category),
                canEdit: !category || !category.other,
                canDelete: !!category && !category.other,
                from: 'team'
            }
        }).catch(() => null).finally(this.reload.bind(this));
    }

    searchBySubmit(terms) {
        let valid = this.search(terms);

        if (valid && this.filteredCategories.length > 0) {
            this.openCategory(this.filteredCategories[0]);
        }
    }

    search(terms) {
        let valid = terms && terms.length > 0;

        this.filteredCategories = valid
            ? filter(this.categories, (category) => categoryHasTerms(category, terms))
            : this.categories;

        this.sortableOptions.disabled = valid;

        return valid;
    }

    endSort() {
        return this.categoryService.reorder(this.teamId, map(this.categories, (category) => category.id)).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to re-order your categories. Please try again later.`));
        }).finally(this.load.bind(this, true));
    }

    dismiss() {
        this.onDismiss();
    }
}

export default {
    selector: 'dbACategoryManageModal',
    template: template(),
    controller: CategoryManageModalController,
    bindings: {
        teamId: '<',
        onDismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/category-manage-modal/category-manage-modal.cmpt.js